import { Pipe, PipeTransform } from '@angular/core';
import { IMenuItem } from '../models/nav-item.model';
import { cloneDeep } from 'lodash';

@Pipe({
  name: 'filterNavMenu',
  standalone: true,
})
export class FilterNavMenuPipe implements PipeTransform {
  transform(menuItems: IMenuItem[], searchString: string): IMenuItem[] {
    if (!searchString) {
      return menuItems;
    }
    return this.getFilteredMenuItems(cloneDeep(menuItems), searchString);
  }

  private getFilteredMenuItems(menuItems: IMenuItem[], searchString: string): IMenuItem[] {
    const result = [] as IMenuItem[];

    menuItems.forEach((menuItem) => {
      const hasNestedMenu: boolean = 'items' in menuItem;

      if (hasNestedMenu) {
        menuItem.items = this.getFilteredMenuItems(menuItem.items as IMenuItem[], searchString);
      }

      if (hasNestedMenu && menuItem.items!.length) {
        result.push(menuItem);
      } else if (!hasNestedMenu && menuItem.label!.toLowerCase().includes(searchString.toLowerCase())) {
        result.push(menuItem);
      }
    });

    return result;
  }
}
